<div class="nxe-breadcrumbs">
    @for (crumb of breadcrumbs$ | async; track $index; let last = $last) {
        <span>
            <button (click)="click(crumb)" class="nxe-breadcrumb-button">{{ crumb.name }}</button>
            @if (!last) {
                <span class="nxe-breadcrumb-separator">
                    <i class="nxe-angle-right" aria-hidden="true"></i>
                </span>
            }
        </span>
    }
</div>
